export default [
    {
        value: "BemPerecivel",
        text: "Bem perecível"
    },
    {
        value: "MaterialDeProcessamentoDeDados",
        text: "Material de processamento de dados"
    },
    {
        value: "MaterialGrafico",
        text: "Material gráfico"
    },
    {
        value: "MaterialParaFotografia",
        text: "Material para fotografia"
    },
    {
        value: "MaterialParaInstalacoesEletricas",
        text: "Material para instalações elétricas"
    },
    {
        value: "MaterialParaTelecomunicacao",
        text: "Material para telecomunicação"
    },
    {
        value: "MaterialQuimico",
        text: "Material químico"
    },
    {
        value: "Outros",
        text: "Outros"
    }
]